export default [
  {
    'name': 'System not integrated / not listed',
    'integrationType': 'notlisted'
  },
  {
    'name': 'Unsure',
    'integrationType': 'unsure'
  },
  {
    'name': 'AbelDent',
    'integrationType': 'oneway'
  },
  {
    'name': 'ACOM Health',
    'integrationType': 'weekly'
  },
  {
    'name': 'Acuity Scheduling',
    'integrationType': 'weekly'
  },
  {
    'name': 'Acusimple',
    'integrationType': 'weekly'
  },
  {
    'name': 'Advanced Data Systems',
    'integrationType': 'reputation'
  },
  {
    'name': 'AdvancedMD',
    'integrationType': 'twoway'
  },
  {
    'name': 'Aesthetic Record',
    'integrationType': 'weekly'
  },
  {
    'name': 'Aesthetics PRO',
    'integrationType': 'weekly'
  },
  {
    'name': 'AgilityOM',
    'integrationType': 'weekly'
  },
  {
    'name': 'AllegianceMD',
    'integrationType': 'weekly'
  },
  {
    'name': 'Allscripts',
    'integrationType': 'twoway'
  },
  {
    'name': 'Amazing Charts',
    'integrationType': 'reputation'
  },
  {
    'name': 'Athena',
    'integrationType': 'twoway'
  },
  {
    'name': 'Atlas.md',
    'integrationType': 'weekly'
  },
  {
    'name': 'Axxium VisionR',
    'integrationType': 'oneway'
  },
  {
    'name': 'Booker',
    'integrationType': 'weekly'
  },
  {
    'name': 'CareCloud',
    'integrationType': 'weekly'
  },
  {
    'name': 'Cerbo',
    'integrationType': 'weekly'
  },
  {
    'name': 'Cerner',
    'integrationType': 'weekly'
  },
  {
    'name': 'ChARM',
    'integrationType': 'weekly'
  },
  {
    'name': 'ChiroTouch',
    'integrationType': 'oneway'
  },
  {
    'name': 'ClearDent',
    'integrationType': 'oneway'
  },
  {
    'name': 'Clinic Doctor',
    'integrationType': 'weekly'
  },
  {
    'name': 'Cloud 9 Ortho',
    'integrationType': 'weekly'
  },
  {
    'name': 'CollaborateMD',
    'integrationType': 'weekly'
  },
  {
    'name': 'Compulink Advantage',
    'integrationType': 'reputation'
  },
  {
    'name': 'Criterions',
    'integrationType': 'weekly'
  },
  {
    'name': 'CureMD',
    'integrationType': 'weekly'
  },
  {
    'name': 'Curve Hero',
    'integrationType': 'weekly'
  },
  {
    'name': 'DentalVision',
    'integrationType': 'oneway'
  },
  {
    'name': 'Dentech',
    'integrationType': 'oneway'
  },
  {
    'name': 'Denticon',
    'integrationType': 'weekly'
  },
  {
    'name': 'DentiMax',
    'integrationType': 'oneway'
  },
  {
    'name': 'Dentrix',
    'integrationType': 'oneway'
  },
  {
    'name': 'Dentrix Ascend',
    'integrationType': 'weekly'
  },
  {
    'name': 'Dolphin Management',
    'integrationType': 'oneway'
  },
  {
    'name': 'Domtrak',
    'integrationType': 'oneway'
  },
  {
    'name': 'Dox Pedo',
    'integrationType': 'oneway'
  },
  {
    'name': 'DrChrono',
    'integrationType': 'twoway'
  },
  {
    'name': 'DSN-Dental',
    'integrationType': 'oneway'
  },
  {
    'name': 'DSN-OMS',
    'integrationType': 'oneway'
  },
  {
    'name': 'DSN-Perio',
    'integrationType': 'oneway'
  },
  {
    'name': 'EagleSoft',
    'integrationType': 'oneway'
  },
  {
    'name': 'Easy Dental',
    'integrationType': 'oneway'
  },
  {
    'name': 'eClinicalWorks 11e & 11 Cloud',
    'integrationType': 'reputation'
  },
  {
    'name': 'eClinicalWorks 10e & 10 Cloud',
    'integrationType': 'oneway'
  },
  {
    'name': 'eClinicalWorks 11 & 10 On-Premise (server-based)',
    'integrationType': 'reputation'
  },
  {
    'name': 'Eclipse',
    'integrationType': 'reputation'
  },
  {
    'name': 'EHI',
    'integrationType': 'weekly'
  },
  {
    'name': 'Elation EMR',
    'integrationType': 'reputation'
  },
  {
    'name': 'eMDs Aprima',
    'integrationType': 'reputation'
  },
  {
    'name': 'eMDs Lytec',
    'integrationType': 'oneway'
  },
  {
    'name': 'eMDs Medisoft',
    'integrationType': 'reputation'
  },
  {
    'name': 'EndoVision',
    'integrationType': 'oneway'
  },
  {
    'name': 'Epic',
    'integrationType': 'weekly'
  },
  {
    'name': 'Experity',
    'integrationType': 'weekly'
  },
  {
    'name': 'Exscribe',
    'integrationType': 'weekly'
  },
  {
    'name': 'Eyefinity',
    'integrationType': 'weekly'
  },
  {
    'name': 'EZDERM',
    'integrationType': 'weekly'
  },
  {
    'name': 'GE Healthcare Centricity',
    'integrationType': 'reputation'
  },
  {
    'name': 'Genesis (for Dental practices)',
    'integrationType': 'oneway'
  },
  {
    'name': 'Genius Doc',
    'integrationType': 'weekly'
  },
  {
    'name': 'Google Calendar',
    'integrationType': 'weekly'
  },
  {
    'name': 'Greenway Intergy',
    'integrationType': 'oneway'
  },
  {
    'name': 'Greenway PrimeSUITE',
    'integrationType': 'twoway'
  },
  {
    'name': 'Harris CareTracker',
    'integrationType': 'weekly'
  },
  {
    'name': 'Healthie',
    'integrationType': 'weekly'
  },
  {
    'name': 'ICANotes',
    'integrationType': 'weekly'
  },
  {
    'name': 'iDentalSoft',
    'integrationType': 'weekly'
  },
  {
    'name': 'InSync',
    'integrationType': 'weekly'
  },
  {
    'name': 'IntakeQ',
    'integrationType': 'weekly'
  },
  {
    'name': 'Jane',
    'integrationType': 'weekly'
  },
  {
    'name': 'Kareo',
    'integrationType': 'twoway'
  },
  {
    'name': 'LiveDDM',
    'integrationType': 'oneway'
  },
  {
    'name': 'MacPractice',
    'integrationType': 'weekly'
  },
  {
    'name': 'Mangomint',
    'integrationType': 'weekly'
  },
  {
    'name': 'Maxident',
    'integrationType': 'oneway'
  },
  {
    'name': 'MDLAND',
    'integrationType': 'weekly'
  },
  {
    'name': 'MedClarity',
    'integrationType': 'weekly'
  },
  {
    'name': 'MedicsPremier',
    'integrationType': 'weekly'
  },
  {
    'name': 'Meditab/Intelligent Medical Software (IMS)',
    'integrationType': 'weekly'
  },
  {
    'name': 'Medent',
    'integrationType': 'weekly'
  },
  {
    'name': 'Medgen',
    'integrationType': 'weekly'
  },
  {
    'name': 'MediaDent',
    'integrationType': 'oneway'
  },
  {
    'name': 'Mindbody',
    'integrationType': 'reputation'
  },
  {
    'name': 'Misys Tiger',
    'integrationType': 'weekly'
  },
  {
    'name': 'Modernizing Medicine / EMA',
    'integrationType': 'oneway'
  },
  {
    'name': 'Modernizing Medicine / gGastro',
    'integrationType': 'weekly'
  },
  {
    'name': 'Mogo',
    'integrationType': 'oneway'
  },
  {
    'name': 'Nextech Select',
    'integrationType': 'reputation'
  },
  {
    'name': 'NextGen Enterprise',
    'integrationType': 'weekly'
  },
  {
    'name': 'NextGen Office (Meditouch or HealthFusion)',
    'integrationType': 'oneway'
  },
  {
    'name': 'OCS-Office Partner',
    'integrationType': 'oneway'
  },
  {
    'name': 'Office Ally',
    'integrationType': 'weekly'
  },
  {
    'name': 'OfficeMate',
    'integrationType': 'oneway'
  },
  {
    'name': 'Office Practicum',
    'integrationType': 'weekly'
  },
  {
    'name': 'OMSVision',
    'integrationType': 'oneway'
  },
  {
    'name': 'One Touch',
    'integrationType': 'weekly'
  },
  {
    'name': 'Open Dental',
    'integrationType': 'oneway'
  },
  {
    'name': 'OpenPM',
    'integrationType': 'weekly'
  },
  {
    'name': 'Opes',
    'integrationType': 'oneway'
  },
  {
    'name': 'OptiMantra',
    'integrationType': 'weekly'
  },
  {
    'name': 'Ortho2 ViewPoint',
    'integrationType': 'oneway'
  },
  {
    'name': 'Ortho2Edge',
    'integrationType': 'oneway'
  },
  {
    'name': 'OrthoNovo',
    'integrationType': 'oneway'
  },
  {
    'name': 'OrthoTrac',
    'integrationType': 'oneway'
  },
  {
    'name': 'Osmind',
    'integrationType': 'weekly'
  },
  {
    'name': 'PatientNOW',
    'integrationType': 'weekly'
  },
  {
    'name': 'PerioVision',
    'integrationType': 'oneway'
  },
  {
    'name': 'Power2Practice',
    'integrationType': 'weekly'
  },
  {
    'name': 'Power Practice Pro',
    'integrationType': 'oneway'
  },
  {
    'name': 'Practice EHR',
    'integrationType': 'weekly'
  },
  {
    'name': 'Practice Fusion / Patient Fusion',
    'integrationType': 'reputation'
  },
  {
    'name': 'Practice Velocity',
    'integrationType': 'weekly'
  },
  {
    'name': 'PracticeWeb',
    'integrationType': 'oneway'
  },
  {
    'name': 'PracticeWorks',
    'integrationType': 'oneway'
  },
  {
    'name': 'Private Practice Software',
    'integrationType': 'oneway'
  },
  {
    'name': 'PrognoCIS',
    'integrationType': 'weekly'
  },
  {
    'name': 'QSIDental Web',
    'integrationType': 'oneway'
  },
  {
    'name': 'Remedly',
    'integrationType': 'weekly'
  },
  {
    'name': 'Revolution EHR',
    'integrationType': 'weekly'
  },
  {
    'name': 'RXNT',
    'integrationType': 'weekly'
  },
  {
    'name': 'SimplePractice',
    'integrationType': 'weekly'
  },
  {
    'name': 'SoftDent',
    'integrationType': 'oneway'
  },
  {
    'name': 'Software of Excellence',
    'integrationType': 'oneway'
  },
  {
    'name': 'SuzyDental',
    'integrationType': 'oneway'
  },
  {
    'name': 'Systemedx',
    'integrationType': 'reputation'
  },
  {
    'name': 'Tracker',
    'integrationType': 'oneway'
  },
  {
    'name': 'Vagaro',
    'integrationType': 'weekly'
  },
  {
    'name': 'Valant',
    'integrationType': 'weekly'
  },
  {
    'name': 'Veracity',
    'integrationType': 'weekly'
  },
  {
    'name': 'WebPT',
    'integrationType': 'weekly'
  },
  {
    'name': 'WinDent',
    'integrationType': 'oneway'
  },
  {
    'name': 'WinDentSQL',
    'integrationType': 'oneway'
  },
  {
    'name': 'WinOMS',
    'integrationType': 'oneway'
  },
  {
    'name': 'XLDent',
    'integrationType': 'oneway'
  }
]



// WEBPACK FOOTER //
// ./src/data/ehr.js